module.exports = __webpack_public_path__ + "static/apple-macbook-pro-15@2x-2c5295b9b80e34ee358adb12fd79c7f8.png";